import { logger } from "#webapp/src/util/logger.util";
import { makeStyles } from "@material-ui/styles";
import React from "react";

import { Nav } from "@clockwise/web-commons/src/components/nav";
import { ExtensionDeprecatedState } from "@clockwise/web-commons/src/ui/extension-deprecated-state";

import { PostMessageManager } from "#webapp/src/util/post-message.util";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

let renderCount = 0;

const useStyles = makeStyles({
  container: {
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    right: 0,
    top: 0,
    bottom: 0,
    width: 300,
    borderLeft: `1px solid ${greys.borderGrey}`,
    background: greys.paleGrey,
  },
});

// This gives us a single component that our entire app is contained under,
// allowing us to wrap the whole app very easily; e.g. for hot-loading
const RootSafari = () => {
  logger.debug("Rendering RootSafari", { renderCount: ++renderCount });
  const classes = useStyles();

  const onCollapse = () => {
    PostMessageManager.closeSidebar();
  };

  return (
    <div className={classes.container}>
      <Nav onClickCollapse={onCollapse} />
      <ExtensionDeprecatedState />
    </div>
  );
};

export default RootSafari;
